"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EventStack = _interopRequireDefault(require("./EventStack"));

var instance = new _EventStack.default();
var _default = instance;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/lib/eventStack/index.js
// module id = 1054
// module chunks = 35783957827783